<template>
  <v-app id="app_measurements">
    <v-overlay v-model="centerLoading" class="custom_centered_overlay">
      <v-progress-circular color="#2A8200" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row class="d-flex align-center justify-space-between">
        <v-col class="mt-0" cols="7">
          <p class="custom_page_main_title">OFFICERS ATTENDANCE ANALYSIS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Used to analyze all the officers' attendance details.
          </p>
        </v-col>

        <v-col class="px-4 mt-0 d-flex justify-end" cols="5">
          <v-row class="custom_tool_bar_style align-center">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="pa-5 mt-5">
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn class="custom_pdf_btn ml-4" variant="outlined" @click="exportPDF">
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="pa-5">
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete v-model="selectedOfficerTitle" :items="officerTitleList" clearable item-title="role_type"
              item-value="id" label="Officer Category" multiple placeholder="All" variant="outlined"
              density="comfortable" class="custom_input_field_color"></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete v-model="selectedOfficer" :items="officersListBasedOnRole" clearable item-title="name"
              item-value="id" label="Officer" multiple placeholder="Select Officer" variant="outlined"
              density="comfortable" class="custom_input_field_color"></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4">
            <v-date-input v-model="dates" label="Select Date Range" prepend-icon="" prepend-inner-icon="$calendar"
              multiple="range" variant="outlined" clearable @click:clear="clearDateRange" density="comfortable"
              class="custom_input_field_color" @update:model-value="onDateRangeSelected" />
          </v-col>
        </v-row>

        <div ref="pdfContent">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-card class="mx-auto pa-4" elevation="0" border="sm opacity-1" rounded="md">
                <p class="font-weight-bold custom_page_component_main_title">
                  ON TIME OFFICERS
                </p>
                <p class="custom_page_main_sub_title_very_small_red">
                  LAST 30 DAYS
                </p>

                <v-divider></v-divider>

                <div class="mt-4">
                  <p class="text-h4 font-weight-bold text-primary">
                    {{ onTimeOfficersPercentage }} %
                  </p>
                  <p class="text-green text-body-2 font-weight-medium" v-if="onTimeOfficersPercentageTrend >= 0">
                    <v-icon size="16" color="green">mdi-arrow-up</v-icon>
                    {{ onTimeOfficersPercentageTrend + " % Increase" }} than
                    last 30 days
                  </p>
                  <p class="text-red text-body-2 font-weight-medium" v-if="onTimeOfficersPercentageTrend < 0">
                    <v-icon size="16" color="red">mdi-arrow-down</v-icon>
                    {{ onTimeOfficersPercentageTrend + " % Decrease" }} than
                    last 30 days
                  </p>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-card class="mx-auto pa-4" elevation="0" border="sm opacity-1" rounded="md">
                <p class="font-weight-bold custom_page_component_main_title">
                  LATE OFFICERS
                </p>
                <p class="custom_page_main_sub_title_very_small_red">
                  LAST 30 DAYS
                </p>

                <v-divider></v-divider>

                <div class="mt-4">
                  <p class="text-h4 font-weight-bold text-primary">
                    {{ lateOfficersPercentage }} %
                  </p>
                  <p class="text-green text-body-2 font-weight-medium" v-if="lateOfficersPercentageTrend >= 0">
                    <v-icon size="16" color="green">mdi-arrow-up</v-icon>
                    {{ lateOfficersPercentageTrend + " % Increase" }} than last
                    30 days
                  </p>
                  <p class="text-red text-body-2 font-weight-medium" v-if="lateOfficersPercentageTrend < 0">
                    <v-icon size="16" color="red">mdi-arrow-down</v-icon>
                    {{ lateOfficersPercentageTrend + " % Decrease" }} than last
                    30 days
                  </p>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-card class="mx-auto pa-4" elevation="0" border="sm opacity-1" rounded="md">
                <p class="font-weight-bold custom_page_component_main_title">
                  OVERTIME REQUEST
                </p>
                <p class="custom_page_main_sub_title_very_small_red">
                  LAST 30 DAYS
                </p>

                <v-divider></v-divider>

                <div class="mt-4">
                  <p class="text-h4 font-weight-bold text-primary">
                    {{ overtimeRequestsPercentage }} %
                  </p>
                  <p class="text-green text-body-2 font-weight-medium" v-if="overtimeRequestsPercentageTrend >= 0">
                    <v-icon size="16" color="green">mdi-arrow-up</v-icon>
                    {{ overtimeRequestsPercentageTrend + " % Increase" }} than
                    last 30 days
                  </p>
                  <p class="text-red text-body-2 font-weight-medium" v-if="overtimeRequestsPercentageTrend < 0">
                    <v-icon size="16" color="red">mdi-arrow-down</v-icon>
                    {{ overtimeRequestsPercentageTrend + " % Decrease" }} than
                    last 30 days
                  </p>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-card class="mx-auto pa-4" elevation="0" border="sm opacity-1" rounded="md">
                <p class="font-weight-bold custom_page_component_main_title">
                  ABSENTS OFFICERS
                </p>
                <p class="custom_page_main_sub_title_very_small_red">
                  LAST 30 DAYS
                </p>

                <v-divider></v-divider>

                <div class="mt-4">
                  <p class="text-h4 font-weight-bold text-primary">
                    {{ absentOfficersPercentage }} %
                  </p>
                  <p class="text-green text-body-2 font-weight-medium" v-if="absentOfficersPercentageTrend >= 0">
                    <v-icon size="16" color="green">mdi-arrow-up</v-icon>
                    {{ absentOfficersPercentageTrend + " % Increase" }} than
                    last 30 days
                  </p>
                  <p class="text-red text-body-2 font-weight-medium" v-if="absentOfficersPercentageTrend < 0">
                    <v-icon size="16" color="red">mdi-arrow-down</v-icon>
                    {{ absentOfficersPercentageTrend + " % Decrease" }} than
                    last 30 days
                  </p>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-card class="pa-5 mt-8">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-card class="mx-auto pa-4 align-center" elevation="0" border="sm opacity-1" rounded="md">
                  <v-row no-gutters align="center">
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                      <p class="text-h6 font-weight-bold mb-0" :style="{ color: ON_TIME_OFFICERS_iconColor }">
                        {{ onTimeOfficersCount }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" xs="12" sm="12" md="1" lg="1">
                      <v-icon size="16" :color="ON_TIME_OFFICERS_iconColor">mdi-square</v-icon>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="10" lg="10">
                      <p class="text-body-2 text-black text-secondary font-weight-medium pt-1">
                        ON TIME OFFICERS
                      </p>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-card class="mx-auto pa-4 align-center" elevation="0" border="sm opacity-1" rounded="md">
                  <v-row no-gutters align="center">
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                      <p class="text-h6 font-weight-bold mb-0" :style="{ color: LATE_OFFICERS_iconColor }">
                        {{ lateOfficersCount }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" xs="12" sm="12" md="1" lg="1">
                      <v-icon size="16" :color="LATE_OFFICERS_iconColor">mdi-square</v-icon>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="10" lg="10">
                      <p class="text-body-2 text-black text-secondary font-weight-medium pt-1">
                        LATE OFFICERS
                      </p>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-card class="mx-auto pa-4 align-center" elevation="0" border="sm opacity-1" rounded="md">
                  <v-row no-gutters align="center">
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                      <p class="text-h6 font-weight-bold mb-0" :style="{ color: ABSENTS_OFFICERS_iconColor }">
                        {{ absentOfficersCount }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" xs="12" sm="12" md="1" lg="1">
                      <v-icon size="16" :color="ABSENTS_OFFICERS_iconColor">mdi-square</v-icon>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="10" lg="10">
                      <p class="text-body-2 text-black text-secondary font-weight-medium pt-1">
                        ABSENTS OFFICERS
                      </p>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                <v-card class="mx-auto pa-4 align-center" elevation="0" border="sm opacity-1" rounded="md">
                  <v-row no-gutters align="center">
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                      <p class="text-h6 font-weight-bold mb-0" :style="{ color: OVERTIME_REQUEST_iconColor }">
                        {{ overtimeRequestsCount }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" xs="12" sm="12" md="1" lg="1">
                      <v-icon size="16" :color="OVERTIME_REQUEST_iconColor">mdi-square</v-icon>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="10" lg="10">
                      <p class="text-body-2 text-black text-secondary font-weight-medium pt-1">
                        OVERTIME REQUEST
                      </p>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>

            <div class="mt-10">
              <BarChart :chartData="barChartData" />
            </div>

            <!-- <v-row align="center" justify="center">
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                            <div ref="chartdiv" style="width: 100%; height: 400px;" class="mt-2"></div>
                        </v-col>
                    </v-row> -->
          </v-card>
        </div>
        <!-- ON TIME OFFICERS LIST TABLE -->

         <!-- <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="mb-0 pa-0">
          <v-row class="mt-3">
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedOfficerTitle"
              :items="officerTitleList"
              clearable
              item-title="role_type"
              item-value="id"
              label="Officer Category"
              multiple
              placeholder="All"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedOfficer"
              :items="officersListBasedOnRole"
              clearable
              item-title="name"
              item-value="id"
              label="Officer"
              multiple
              placeholder="Select Officer"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
            ></v-autocomplete>
          </v-col>

         
        </v-row>
         </v-col> -->


        <!-- LAST TIME OFFICERS LIST TABLE -->

        <v-row class="align-center mt-10">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <div class="d-flex align-center flex-grow-1">
              <p class="custom_page_component_main_title ma-0">
                LATE TIME OFFICERS LIST
              </p>
            </div>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="auto">
            <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcelLateTimeOfficerList">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-data-table :group-by="groupByLASTTIMEOFFICERS" :headers="LASTTIMEOFFICERSheaders"
          :items="lateTimeOfficersList" item-value="user_id">
          <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
            <tr>
              <td :colspan="columns.length">
                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                  @click="toggleGroup(item)"></VBtn>
                <!-- <div> -->
                <span class="text-muted">
                  {{ item.value.split(" - ")[0] }}
                  <!-- {{ item.user.name }} -->
                </span>
                <br />
                <span class="blue--text font-weight-bold pl-10">Employee ID: {{ item.value.split(" - ")[1] }}</span>
                <!-- </div> -->
              </td>
            </tr>
          </template>

          <template v-slot:[`item.dayIn`]="{ item }">
            <div>
              <div v-if="item.day_in_time && item.day_in_location">
                <span>{{ item.day_in_time }}</span> <br />
                <span class="blue--text font-weight-bold">
                  {{ item.day_in_location }}
                </span>
              </div>
              <div v-else>
                <span>Not yet</span>
              </div>
            </div>
          </template>


          <template v-slot:[`item.dayOut`]="{ item }">
            <div v-if="item.day_out_time && item.day_out_location">
              <span>{{ item.day_out_time }}</span> <br />
              <span class="blue--text font-weight-bold">
                {{ item.day_out_location }}
              </span>
            </div>
            <div v-else>
              <span>Not yet</span>
            </div>
          </template>

          <template v-slot:[`item.day_in_date`]="{ item }">
            <div v-if="item.day_in_date">
              {{
                new Date(item.day_in_date)
                  .toISOString()
                  .slice(0, 10)
                  .replace(/-/g, "/")
              }}
            </div>
            <div v-else>
              <span>Not yet</span>
            </div>
          </template>

          <template v-slot:[`item.working_hours`]="{ item }">
            <div v-if="item.working_hours">
              {{ formatWorkingHours(item.working_hours) }}
            </div>
            <div v-else>
              <span>Not yet</span>
            </div>
          </template>

        </v-data-table>

        <!--OVERTIME REQUEST OFFICERS LIST TABLE -->

        <v-row class="align-center mt-10">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <div class="d-flex align-center flex-grow-1">
              <p class="custom_page_component_main_title ma-0">
                OVERTIME REQUEST OFFICERS LIST
              </p>
            </div>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="auto">
            <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcelOvertimeRequestOfficerList">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-data-table :group-by="groupByRequestOfficers" :headers="headersByRequestOfficers"
          :items="overtimeRequestOfficesList" item-value="user_id">
          <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
            <tr>
              <td :colspan="columns.length">
                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                  @click="toggleGroup(item)"></VBtn>
                <span class="text-muted">
                  {{ item.value.split(" - ")[0] }}
                </span>
                <br />
                <span class="blue--text font-weight-bold pl-10">Employee ID: {{ item.value.split(" - ")[1] }}</span>
              </td>
            </tr>
          </template>

          <template v-slot:[`item.dayIn`]="{ item }">
            <div>
              <div v-if="item.attendance != null">
                <span>{{ item.attendance.day_in_time }}</span> <br />
                <span class="blue--text font-weight-bold">{{
                  item.attendance.day_in_location
                }}</span>
              </div>
              <div v-else>
                <span>Not yet</span>
              </div>
            </div>
          </template>

          <template v-slot:[`item.dayOut`]="{ item }">
            <div v-if="item.attendance != null">
              <span>{{ item.attendance.day_out_time }}</span> <br />
              <span class="blue--text font-weight-bold">{{
                item.attendance.day_out_location
              }}</span>
            </div>
            <div v-else>
              <span>Not yet</span>
            </div>
          </template>

          <template v-slot:[`item.request_hours`]="{ item }">
            <div class="text-left">
              <span class="blue--text"><strong class="black--text font-weight-bold">From:</strong>
                {{ item.request_time_from }}</span><br />
              <span class="blue--text"><strong class="black--text font-weight-bold">To:</strong>
                {{ item.request_time_to }}</span><br />
              <span class="red--text"><strong class="black--text font-weight-bold">Hours:</strong>
                {{ item.request_hours }}</span>
            </div>
          </template>
          <template v-slot:[`item.allWorkingHrs`]="{ item }">
            <span v-if="item.attendance != null">{{
              item.attendance.day_out_time != null
                ? formatWorkingHours(item.attendance.working_hours)
                : "Not Yet"
            }}</span>
            <span v-else>{{ "No Attendance" }}</span>
          </template>
        </v-data-table>

        <!--ABSENTS OFFICERS LIST OFFICERS LIST TABLE -->

        <v-row class="align-center mt-10">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <div class="d-flex align-center flex-grow-1">
              <p class="custom_page_component_main_title ma-0">
                ABSENTS OFFICERS LIST
              </p>
            </div>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="auto">
            <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcelAbsentOfficerList">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-data-table :group-by="groupByAbsentsOfficers" :headers="headersByAbsentsOfficers" :items="absentOfficersList"
          item-value="user_id">
          <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
            <tr>
              <td :colspan="columns.length">
                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                  @click="toggleGroup(item)"></VBtn>
                <span class="text-muted">
                  {{ item.value.split(" - ")[0] }}
                  <!-- {{ item.user.name }} -->
                </span>
                <br />
                <span class="blue--text font-weight-bold pl-10">Employee ID: {{ item.value.split(" - ")[1] }}</span>
              </td>
            </tr>
          </template>

          <!-- Row Content -->
          <!-- <template v-slot:item="{ item }">
                    <span class="blue--text">{{ item.dayIn }}</span>
                    </template>
                     -->
        </v-data-table>

        <!--OFFICERS ON HALF DAY LEAVE TABLE -->

        <v-row class="align-center mt-10">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3">
            <div class="d-flex align-center flex-grow-1">
              <p class="custom_page_component_main_title ma-0">
                OFFICERS ON HALF DAY LEAVE
              </p>
            </div>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="auto">
            <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcelHalfDayLeaveOfficerList">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-data-table :group-by="groupByHalfDay" :headers="headersByHalfDay" :items="halfDayLeaveOfficersList"
          item-value="name">
          <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
            <tr>
              <td :colspan="columns.length">
                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                  @click="toggleGroup(item)"></VBtn>
                <span class="text-muted">
                  {{ item.value.split(" - ")[0] }}
                  <!-- {{ item.user.name }} -->
                </span>
                <br />
                <span class="blue--text font-weight-bold pl-10">Employee ID: {{ item.value.split(" - ")[1] }}</span>
              </td>
            </tr>
          </template>

          <template v-slot:[`item.dayIn`]="{ item }">
            <div v-if="item.day_in_time && item.day_in_location">
              <span>{{ item.day_in_time }}</span> <br />
              <span class="blue--text font-weight-bold">
                {{ item.day_in_location }}
              </span>
            </div>
            <div v-else>
              <span>Not yet</span>
            </div>
          </template>


          <template v-slot:[`item.dayOut`]="{ item }">
            <div v-if="item.day_out_time && item.day_out_location">
              <span>{{ item.day_out_time }}</span> <br />
              <span class="blue--text font-weight-bold">
                {{ item.day_out_location }}
              </span>
            </div>
            <div v-else>
              <span>Not yet</span>
            </div>
          </template>

          <template v-slot:[`item.working_hours`]="{ item }">
            <div v-if="item.working_hours">
              {{ formatWorkingHours(item.working_hours) }}
            </div>
            <div v-else>
              <span>Not yet</span>
            </div>
          </template>


          <template v-slot:[`item.day_in_date`]="{ item }">
            <div>
              <v-chip v-if="item.is_afternoon_half_day == 1" small outlined style="
                  border: 1px solid #ffa500;
                  color: #000000;
                  background-color: #ffc647;
                ">
                AFTERNOON-HD LEAVE
              </v-chip>
              <v-chip v-if="item.is_morning_half_day == 1" small outlined style="
                  border: 1px solid #ffa500;
                  color: #000000;
                  background-color: #6aff47;
                ">
                MORNING-HD LEAVE
              </v-chip>
              <br />

              <span>{{
                new Date(item.day_in_date)
                  .toISOString()
                  .slice(0, 10)
                  .replace(/-/g, "/")
              }}</span>
            </div>
          </template>

          <!-- Custom Column for Date -->
        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script setup>
import BarChart from "@/components/AttendanceManagement/BarChart.vue";
</script>
<script>
import axios from "axios";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable";
export default {
  data() {
    return {
      centerLoading: false,
      onTimeOfficersPercentage: "",
      lateOfficersPercentage: "",
      overtimeRequestsPercentage: "",
      absentOfficersPercentage: "",
      onTimeOfficersPercentageTrend: "",
      lateOfficersPercentageTrend: "",
      overtimeRequestsPercentageTrend: "",
      absentOfficersPercentageTrend: "",
      onTimeOfficersCount: "",
      lateOfficersCount: "",
      overtimeRequestsCount: "",
      absentOfficersCount: "",

      onTimeOfficersDaysData: null,
      lateOfficersDaysData: null,
      overtimeRequestsDaysData: null,
      absentOfficersDaysData: null,

      onTimeOfficersList: [],
      lateTimeOfficersList: [],
      absentOfficersList: [],
      halfDayLeaveOfficersList: [],
      overtimeRequestOfficesList: [],

      officerTitleList: [],
      officersListBasedOnRole: [],
      selectedOfficerTitle: null,
      selectedOfficer: null,

      startDate: null,
      endDate: null,

      dates: null,

      barChartData: null,

      ON_TIME_OFFICERS_iconColor: "#468af6",
      OVERTIME_REQUEST_iconColor: "#efac00",
      ABSENTS_OFFICERS_iconColor: "#9747ff",
      LATE_OFFICERS_iconColor: "#00368c",

      //  ON TIME OFFICERS LIST TABLE

      groupBy: [
        {
          key: "group_by_user",
          order: "asc",
        },
      ],
      headers: [
        {
          title: "OFFICER NAME",
          align: "start",
          sortable: false,
          key: "user.name",
        },
        { title: "DAY IN", key: "dayIn" },
        { title: "DAY OUT", key: "dayOut" },
        { title: "WORKING HOURS", key: "working_hours" },
        { title: "DATE", key: "day_in_date" },
      ],

      // LAST TIME OFFICERS LIST TABLE

      groupByLASTTIMEOFFICERS: [
        {
          key: "group_by_user",
          order: "asc",
        },
      ],
      LASTTIMEOFFICERSheaders: [

        { title: "DAY IN", key: "dayIn" },
        { title: "DAY OUT", key: "dayOut" },
        { title: "WORKING HOURS", key: "working_hours" },
        { title: "DATE", key: "day_in_date" },
      ],
      LASTTIMEOFFICERSdesserts: [
        {
          officerName: "Mr. Tharindu Chandrasiri",
          dayIn: {
            time: "8:23 AM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          dayOut: {
            time: "4:55 PM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          workingHours: "9 hours 12 minutes",
          date: "2025-01-01",
          gluten: false,
        },
        {
          officerName: "Mr. Ransilu Obeysekera",
          dayIn: {
            time: "8:23 AM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          dayOut: {
            time: "4:55 PM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          workingHours: "8 hours 56 minutes",
          date: "2025-01-03",
          gluten: false,
        },
        {
          officerName: "Mr. Ransilu Obeysekera",
          dayIn: {
            time: "8:23 AM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          dayOut: {
            time: "4:55 PM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          workingHours: "9 hours 13 minutes",
          date: "2025-01-04",
          gluten: true,
        },
      ],

      // OVERTIME REQUEST OFFICERS LIST TABLE
      groupByRequestOfficers: [
        {
          key: "group_by_user",
          order: "asc",
        },
      ],
      headersByRequestOfficers: [
        { title: "DAY IN", key: "dayIn" },
        { title: "DAY OUT", key: "dayOut" },
        { title: "ALL WORKING HR", key: "allWorkingHrs" },
        { title: "REQUEST HOURS", key: "request_hours" },
        { title: "DATE", key: "date" },
      ],

      // ABSENTS OFFICERS LIST TABLE
      groupByAbsentsOfficers: [
        {
          key: "group_by_user",
          order: "asc",
        },
      ],
      headersByAbsentsOfficers: [

        { title: "DATE", key: "date" },
      ],
      dessertsByAbsentsOfficers: [
        {
          officerName: "Mr. Tharindu Chandrasiri",
          date: "2025-01-01",
          gluten: false,
        },
        {
          officerName: "Mr. Ransilu Obeysekera",
          date: "2025-01-03",
          gluten: false,
        },
        {
          officerName: "Mr. Ransilu Obeysekera",
          date: "2025-01-04",
          gluten: true,
        },
      ],

      // OVERTIME REQUEST OFFICERS LIST TABLE
      groupByHalfDay: [
        {
          key: "group_by_user",
          order: "asc",
        },
      ],
      headersByHalfDay: [

        { title: "DAY IN", key: "dayIn" },
        { title: "DAY OUT", key: "dayOut" },
        { title: "WORKING HOURS", key: "working_hours" },
        { title: "DATE", key: "day_in_date" },
      ],
      dessertsByHalfDay: [
        {
          officerName: "Mr. Tharindu Chandrasiri",
          dayIn: {
            time: "8:23 AM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          dayOut: {
            time: "4:55 PM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          workingHours: "9 hours 12 minutes",
          date: "2025-01-01",
          gluten: false,
        },
        {
          officerName: "Mr. Ransilu Obeysekera",
          dayIn: {
            time: "8:23 AM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          dayOut: {
            time: "4:55 PM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          workingHours: "8 hours 56 minutes",
          date: "2025-01-03",
          gluten: false,
        },
        {
          officerName: "Mr. Ransilu Obeysekera",
          dayIn: {
            time: "8:23 AM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          dayOut: {
            time: "4:55 PM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          workingHours: "9 hours 13 minutes",
          date: "2025-01-04",
          gluten: true,
        },
      ],
    };
  },
  created() {
    this.getOfficerTitles();
    this.getDashboardStaticsData();
    this.getOnTimeOfficersList();
    this.getLateTimeOfficersList();
    this.getAbsentOfficersList();
    this.getHalfDayLeaveOfficersList();
    this.getOvertimeRequestOfficersList();
  },

  watch: {
    selectedOfficerTitle(newVal) {
      this.selectedOfficer = "";
      this.getUserListBasedOnRoles(newVal); // This triggers on every checkbox change
    },
    selectedOfficer(newVal) {
      this.selectedOfficer = newVal;
      this.callToMainFunctions();
    },
  },

  methods: {
    getDashboardStaticsData() {
      this.centerLoading = true;
      // const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/aad/web/get-statistics-attendance-data`,
          { startDate: this.startDate, endDate: this.endDate },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            },
          }
        )
        .then((response) => {
          this.onTimeOfficersPercentage = response.data.onTimeOfficerPercentage;
          this.lateOfficersPercentage = response.data.lateTimeOfficerPercentage;
          this.overtimeRequestsPercentage =
            response.data.overtimeRequestPercentage;
          this.absentOfficersPercentage = response.data.absentOfficerPercentage;

          this.onTimeOfficersPercentageTrend =
            response.data.trends.on_time_trend;
          this.lateOfficersPercentageTrend = response.data.trends.late_trend;
          this.overtimeRequestsPercentageTrend =
            response.data.trends.overtime_trend;
          this.absentOfficersPercentageTrend =
            response.data.trends.absent_trend;

          this.onTimeOfficersCount = response.data.onTimeOfficersCount;
          this.lateOfficersCount = response.data.lateTimeOfficersCount;
          this.overtimeRequestsCount = response.data.overtimeRequestCount;
          this.absentOfficersCount = response.data.absentOfficersCount;

          this.onTimeOfficersDaysData = response.data.onTimeOfficersByDay;
          this.lateOfficersDaysData = response.data.lateTimeOfficersByDay;
          this.overtimeRequestsDaysData = response.data.overtimeRequestsByDay;
          this.absentOfficersDaysData = response.data.absentOfficersByDay;

          // Function to normalize date to YYYY-MM-DD
          const normalizeDate = (dateStr) => {
            return dateStr.replace(/\//g, "-");
          };

          // Map to combine data
          const mergedDataMap = {};

          // Add onTimeOfficersByDay data
          this.onTimeOfficersDaysData.forEach((item) => {
            const date = normalizeDate(item.date);
            if (!mergedDataMap[date]) mergedDataMap[date] = { date };
            mergedDataMap[date].onTime = item.count;
          });

          // Add latetimeRequestsByDay data
          this.lateOfficersDaysData.forEach((item) => {
            const date = normalizeDate(item.date);
            if (!mergedDataMap[date]) mergedDataMap[date] = { date };
            mergedDataMap[date].latetime = item.count;
          });

          // Add overtimeRequestsByDay data
          this.overtimeRequestsDaysData.forEach((item) => {
            const date = normalizeDate(item.date);
            if (!mergedDataMap[date]) mergedDataMap[date] = { date };
            mergedDataMap[date].overtime = item.count;
          });

          // Add absentRequestsByDay data
          this.absentOfficersDaysData.forEach((item) => {
            const date = normalizeDate(item.date);
            if (!mergedDataMap[date]) mergedDataMap[date] = { date };
            mergedDataMap[date].absentTime = item.count;
          });

          // Convert map to array and fill missing values with 0
          this.barChartData = Object.values(mergedDataMap).map((item) => ({
            date: item.date,
            onTime: item.onTime || 0,
            lateTime: item.latetime || 0,
            overtime: item.overtime || 0,
            absentTime: item.absentTime || 0,
          }));

          this.centerLoading = false;

        })
        .catch((error) => {
          this.centerLoading = false;
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    getOnTimeOfficersList() {
      this.centerLoading = true;
      // const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/aad/web/get-on-time-officers-data`,
          {
            startDate: this.startDate,
            endDate: this.endDate,
            selectedOfficers: this.selectedOfficer,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            },
          }
        )
        .then((response) => {
          this.onTimeOfficersList = response.data.data;

          this.centerLoading = false;

        })
        .catch((error) => {
          this.centerLoading = false;
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    backPageRoute() {
      this.$router.go(-1);
    },

    exportExcelOnTimeOfficerList() {
      let tableData = [];
      if (this.onTimeOfficersList.length > 0) {
        tableData = this.onTimeOfficersList.map((item, index) => ({
          "#": index + 1,
          "Officer Name": item.user.name,
          "EMPLOYEE ID": item.user.registration_num,
          "Day In Date": item.day_in_date,
          "Day In Time": item.day_in_time,
          "Day In Location": item.day_in_location,
          "Day Out Date": item.day_out_date,
          "Day Out Time": item.day_out_time,
          "Day Out Location": item.day_out_location,
          "Working Hours": item.working_hours,
        }));
      } else {
        tableData = [{
          "#": "",
          "Officer Name": "",
          "EMPLOYEE ID": "",
          "Day In Date": "",
          "Day In Time": "",
          "Day In Location": "",
          "Day Out Date": "",
          "Day Out Time": "",
          "Day Out Location": "",
          "Working Hours": "",
        }];
      }

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "On Time Officers List"
      );
      XLSX.writeFile(workbook, "On_Time_Officers_List.xlsx");

      const fileName = "On_Time_Officers_List.xlsx";
      const file_type = "excel";
      this.logDocumentDownload(fileName, file_type, "On Time Officers List");
    },

    getLateTimeOfficersList() {
      this.centerLoading = true;
      // const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/aad/web/get-late-time-officers-data`,
          {
            startDate: this.startDate,
            endDate: this.endDate,
            selectedOfficers: this.selectedOfficer,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            },
          }
        )
        .then((response) => {
          this.lateTimeOfficersList = response.data.data;

          this.centerLoading = false;

        })
        .catch((error) => {
          this.centerLoading = false;
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    exportExcelLateTimeOfficerList() {
      let tableData = [];
      if (this.lateTimeOfficersList.length > 0) {
        tableData = this.lateTimeOfficersList.map((item, index) => ({
          "#": index + 1,
          "Officer Name": item.user.name,
          "EMPLOYEE ID": item.user.registration_num,
          "Day In Date": item.day_in_date,
          "Day In Time": item.day_in_time,
          "Day In Location": item.day_in_location,
          "Day Out Date": item.day_out_date,
          "Day Out Time": item.day_out_time,
          "Day Out Location": item.day_out_location,
          "Working Hours": item.working_hours,
        }));
      } else {
        tableData = [{
          "#": "",
          "Officer Name": "",
          "EMPLOYEE ID": "",
          "Day In Date": "",
          "Day In Time": "",
          "Day In Location": "",
          "Day Out Date": "",
          "Day Out Time": "",
          "Day Out Location": "",
          "Working Hours": "",
        }];
      }

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Late Time Officers List"
      );
      XLSX.writeFile(workbook, "Late_Time_Officers_List.xlsx");

      const fileName = "Late_Time_Officers_List.xlsx";
      const file_type = "excel";
      this.logDocumentDownload(fileName, file_type, "Late Time Officers List");
    },

    getAbsentOfficersList() {
      this.centerLoading = true;
      // const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/aad/web/get-absent-officers-data`,
          {
            startDate: this.startDate,
            endDate: this.endDate,
            selectedOfficers: this.selectedOfficer,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            },
          }
        )
        .then((response) => {
          this.absentOfficersList = response.data.data;

          this.centerLoading = false;

        })
        .catch((error) => {
          this.centerLoading = false;
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    exportExcelAbsentOfficerList() {
      let tableData = [];
      if (this.absentOfficersList.length > 0) {
        tableData = this.absentOfficersList.map((item, index) => ({
          "#": index + 1,
          "Officer Name": item.user_name,
          "EMPLOYEE ID": item.user_reg_number,
          Date: item.date,
          Reason: item.reason,
        }));
      } else {
        tableData = [{
          "#": "",
          "Officer Name": "",
          "EMPLOYEE ID": "",
          "Date": "",
          "Reason": "",
        }];
      }

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Absent Officers List");
      XLSX.writeFile(workbook, "Absent_Officers_List.xlsx");

      const fileName = "Absent_Officers_List.xlsx";
      const file_type = "excel";
      this.logDocumentDownload(fileName, file_type, "Absent Officers List");
    },

    getHalfDayLeaveOfficersList() {
      this.centerLoading = true;
      // const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/aad/web/get-half-day-leave-officers-data`,
          {
            startDate: this.startDate,
            endDate: this.endDate,
            selectedOfficers: this.selectedOfficer,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            },
          }
        )
        .then((response) => {
          this.halfDayLeaveOfficersList = response.data.data;

          this.centerLoading = false;

        })
        .catch((error) => {
          this.centerLoading = false;
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    exportExcelHalfDayLeaveOfficerList() {
      let tableData = [];
      if (this.halfDayLeaveOfficersList.length > 0) {
        tableData = this.halfDayLeaveOfficersList.map((item, index) => ({
          "#": index + 1,
          "Officer Name": item.user.name,
          "EMPLOYEE ID": item.user.registration_num,
          "Day In Date": item.day_in_date,
          "Day In Time": item.day_in_time,
          "Day In Location": item.day_in_location,
          "Day Out Date": item.day_out_date,
          "Day Out Time": item.day_out_time,
          "Day Out Location": item.day_out_location,
          "Working Hours": item.working_hours,
          "Morning Half Day Leave": item.is_morning_half_day == 1 ? "Yes" : "No",
          "AfterNoon Half Day Leave":
            item.is_afternoon_half_day == 1 ? "Yes" : "No",
        }));
      } else {
        tableData = [{
          "#": "",
          "Officer Name": "",
          "EMPLOYEE ID": "",
          "Day In Date": "",
          "Day In Time": "",
          "Day In Location": "",
          "Day Out Date": "",
          "Day Out Time": "",
          "Day Out Location": "",
          "Working Hours": "",
          "Morning Half Day Leave": "",
          "AfterNoon Half Day Leave": "",
        }];
      }

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Half Day Leave Officers List"
      );
      XLSX.writeFile(workbook, "Half_Day_Leave_Officers_List.xlsx");

      const fileName = "Half_Day_Leave_Officers_List.xlsx";
      const file_type = "excel";
      this.logDocumentDownload(
        fileName,
        file_type,
        "Half Day Leave Officers List"
      );
    },

    getOvertimeRequestOfficersList() {
      this.centerLoading = true;
      // const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/aad/web/get-overtime-request-officers-data`,
          {
            startDate: this.startDate,
            endDate: this.endDate,
            selectedOfficers: this.selectedOfficer,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            },
          }
        )
        .then((response) => {
          this.overtimeRequestOfficesList = response.data.data;

          this.centerLoading = false;

        })
        .catch((error) => {
          this.centerLoading = false;
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    exportExcelOvertimeRequestOfficerList() {
      let tableData = [];
      if (this.overtimeRequestOfficesList.length > 0) {
        tableData = this.overtimeRequestOfficesList.map((item, index) => ({
          "#": index + 1,
          "Officer Name": item.user.name,
          "EMPLOYEE ID": item.user.reg_num,
          "Day In Date": item.attendance
            ? item.attendance.day_in_date
            : "Not yet",
          "Day In Time": item.attendance
            ? item.attendance.day_in_time
            : "Not yet",
          "Day Out Date": item.attendance
            ? item.attendance.day_out_date
            : "Not yet",
          "Day Out Time": item.attendance
            ? item.attendance.day_out_time
            : "Not yet",
          "Request Time From": item.request_time_from,
          "Request Time To": item.request_time_to,
          "Request Date From": item.date,
          "Requested Hours": item.request_hours,
          "Working Hours": "",
        }));
      } else {
        tableData = [{
          "#": "",
          "Officer Name": "",
          "EMPLOYEE ID": "",
          "Day In Date": "",
          "Day In Time": "",
          "Day Out Date": "",
          "Day Out Time": "",
          "Request Time From": "",
          "Request Time To": "",
          "Request Date From": "",
          "Requested Hours": "",
          "Working Hours": "",
        }];
      }

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Over time Request Officers List"
      );
      XLSX.writeFile(workbook, "Over_time_Request_Officers_List.xlsx");

      const fileName = "Over_time_Request_Officers_List.xlsx";
      const file_type = "excel";
      this.logDocumentDownload(
        fileName,
        file_type,
        "Over time Request Officers List"
      );
    },

    async exportPDF() {
      this.centerLoading = true;
      const element = this.$refs.pdfContent;

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      // const pageHeight = pdf.internal.pageSize.getHeight();

      const marginX = 10; // left and right margin in mm
      const marginY = 10; // top and bottom margin in mm

      const contentWidth = pageWidth - marginX * 2;
      const imgProps = pdf.getImageProperties(imgData);
      const contentHeight = (imgProps.height * contentWidth) / imgProps.width;

      // If the content height exceeds one page, you can add page splitting logic here

      pdf.addImage(
        imgData,
        "PNG",
        marginX,
        marginY,
        contentWidth,
        contentHeight
      );

      pdf.save("Attendance Analysis Statistical Dashboard Report.pdf");
      this.centerLoading = false;

      const fileName = "dashboard.pdf";
      const file_type = "pdf";
      this.logDocumentDownload(fileName, file_type, "Dashboard Statistical Data");
    },

    getOfficerTitles() {
      this.centerLoading = true;
      // const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/um/web/get-mobile-user-roles`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            },
          }
        )
        .then((response) => {
          this.officerTitleList = response.data.data;

          this.centerLoading = false;

        })
        .catch((error) => {
          this.centerLoading = false;
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    getUserListBasedOnRoles(selectedRoles) {
      this.centerLoading = true;
      // const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/um/web/get-mobile-users-based-on-roles`,
          { userRoleId: selectedRoles },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            },
          }
        )
        .then((response) => {
          this.officersListBasedOnRole = response.data.data;

          this.centerLoading = false;

        })
        .catch((error) => {
          this.centerLoading = false;
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    onDateRangeSelected(newDates) {
      if (newDates) {
        this.dates = newDates;

        this.startDate = new Date(this.dates[0]);
        this.startDate.setDate(this.startDate.getDate() + 1);
        this.startDate = this.startDate.toISOString().split("T")[0];
        this.endDate = this.dates.length > 1 ? new Date(this.dates[this.dates.length - 1]).toISOString().split('T')[0] : this.startDate;

        this.callToMainFunctions();


      } else {
        this.dates = null;
        this.startDate = null;
        this.endDate = null;
        this.callToMainFunctions();
      }
    },

    callToMainFunctions() {
      this.getDashboardStaticsData();
      this.getOnTimeOfficersList();
      this.getLateTimeOfficersList();
      this.getAbsentOfficersList();
      this.getHalfDayLeaveOfficersList();
      this.getOvertimeRequestOfficersList();
    },

    formatWorkingHours(hoursStr) {
      const [hours, minutes] = hoursStr.split(":").map(Number);
      return `${hours} hours ${minutes.toString().padStart(2, "0")} minutes`;
    },

    async logDocumentDownload(fileName, file_type, entityArea) {

      try {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        if (!userId) {
          throw new Error("User ID not found");
        }

        // Asynchronous API call to log download
        const response = await axios.post(`/api/log-document-download`, {
          user_id: userId,
          file_type: file_type,
          file_name: fileName,
          entity_area: entityArea,

          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.status !== 200) {
          throw new Error("Failed to log download");
        }


      } catch (error) {
        console.error("Error logging download:", error);
      }
    },
  },
};
</script>

<style scoped>
.blue--text {
  color: blue;
}

.red--text {
  color: red;
}

.black--text {
  color: black;
}
</style>